import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-357d923e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login flex h-full bg-white overflow-hidden" }
const _hoisted_2 = { class: "left relative w-1/2 xl:block h-full bg-primary rounded-r-2xl hidden" }
const _hoisted_3 = { class: "right w-full xl:w-1/2 flex bg-white z-30 overflow-y-auto px-10" }
const _hoisted_4 = { class: "centered m-auto py-5" }
const _hoisted_5 = { class: "scale-75 sm:scale-100" }
const _hoisted_6 = { class: "title-section text-center mt-0 sm:mt-12" }
const _hoisted_7 = { class: "text-black-700 text-xl font-ubuntu sm:text-3xl" }
const _hoisted_8 = { class: "mt-4 sm:mt-12" }
const _hoisted_9 = ["placeholder", "disabled"]
const _hoisted_10 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_11 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_12 = { class: "mt-4 relative" }
const _hoisted_13 = ["type", "placeholder", "disabled"]
const _hoisted_14 = { class: "see-password cursor-pointer text-right float-right max-w-fit right-4 absolute top-5" }
const _hoisted_15 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_16 = {
  key: 1,
  class: "font-light text-red-500"
}
const _hoisted_17 = { class: "align-right w-full flex mt-1" }
const _hoisted_18 = { class: "mt-4 sm:mt-8" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  style: {"display":"inherit","margin-bottom":"2px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackGround = _resolveComponent("BackGround")!
  const _component_DartsLogo = _resolveComponent("DartsLogo")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PasswordRecoveryModal = _resolveComponent("PasswordRecoveryModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BackGround, { class: "absolute bottom-0" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DartsLogo, { class: "logo color-white z-20 object-none object-center relative m-auto signature-animation" })
          ]),
          _createElementVNode("form", {
            class: "form m-auto",
            "on:submit": _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.performLogin()), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t(_ctx.isAdmin ? 'login-page.title-admin' : 'login-page.title-manager')), 1)
              ]),
              _createElementVNode("p", {
                class: _normalizeClass(["open-sans text-gray-400 justify-center text-xs text-lg", _ctx.isAdmin ? 'opacity-0 mt-2.5 h-1 z-0' : 'mt-2.5'])
              }, _toDisplayString(_ctx.$t('login-page.subtitle')), 3)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["appearance-none rounded w-full px-3 text-black-700 leading-tight bg-gray-100 focus:outline-none focus:shadow-outline", { disabled: _ctx.isLoading, border: _ctx.v$.email.$error }]),
                id: "email",
                type: "email",
                placeholder: _ctx.$t('login-page.email.placeholder'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.email.$touch && _ctx.v$.email.$touch(...args))),
                disabled: _ctx.isLoading
              }, null, 42, _hoisted_9), [
                [_vModelText, _ctx.email]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errors",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_10, _toDisplayString(_ctx.$t('login-page.email.required')), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'email')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_11, _toDisplayString(_ctx.$t('login-page.email.valid')), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["appearance-none rounded w-full px-3 text-black-700 leading-tight bg-gray-100 focus:outline-none focus:shadow-outline", { disabled: _ctx.isLoading,border: _ctx.v$.password.$error }]),
                id: "password",
                type: _ctx.passwordFieldType,
                placeholder: _ctx.$t('login-page.password.placeholder'),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.password.$touch && _ctx.v$.password.$touch(...args))),
                disabled: _ctx.isLoading
              }, null, 42, _hoisted_13), [
                [_vModelDynamic, _ctx.password]
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.isSeePassword)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      class: "h-5",
                      icon: ['fas', 'eye-slash'],
                      onClick: _ctx.seeHidePassword
                    }, null, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      class: "h-5",
                      icon: ['fas', 'eye'],
                      onClick: _ctx.seeHidePassword
                    }, null, 8, ["onClick"]))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.password.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errors",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_15, _toDisplayString(_ctx.$t('login-page.password.required')), 1))
                    : _createCommentVNode("", true),
                  (error.$validator == 'minLength')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_16, _toDisplayString(_ctx.$t('login-page.password.min-length', { chars: _ctx.passwordMinLength })), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  class: "ml-auto forgot-password text-right relative ubuntu text-xs cursor-pointer",
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPasswordRecovery && _ctx.onPasswordRecovery(...args)), ["stop"]))
                }, _toDisplayString(_ctx.$t('login-page.button.forgot-password')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: _normalizeClass(["bg-primary text-white text-xl font-bold py-4 px-4 rounded w-full ubuntu hover:bg-primary-600 focus:outline-none focus:shadow-outline", { disabled : _ctx.v$.$invalid }]),
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.performLogin && _ctx.performLogin(...args))),
                disabled: _ctx.v$.$invalid || _ctx.isLoading
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_23))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(_ctx.$t('login-page.button.login')), 1)
              ], 10, _hoisted_19)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["sign-in mt-8 text-center xl:mt-32", _ctx.isAdmin ? 'opacity-0' : ''])
            }, [
              _createElementVNode("button", {
                class: "ubuntu text-center",
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goSignUp && _ctx.goSignUp(...args))),
                innerHTML: _ctx.$t('login-page.button.sign-up')
              }, null, 8, _hoisted_24)
            ], 2)
          ], 32)
        ])
      ])
    ]),
    (_ctx.isShowPasswordRecovery)
      ? (_openBlock(), _createBlock(_component_PasswordRecoveryModal, {
          key: 0,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isShowPasswordRecovery = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}